import { render, staticRenderFns } from "./b-renew.vue?vue&type=template&id=5d813e78&"
import script from "./b-renew.vue?vue&type=script&lang=js&"
export * from "./b-renew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports